<template>
  <div class="inventory">
    <div class="inventory__left">
      <div class="inventory__image">
        <img
          v-if="inventory.image"
          :src="inventory.image"
          :alt="inventory.name"
        />
      </div>
    </div>
    <div class="inventory__right">
      <span class="inventory__name">
        <span v-html="inventory.name"></span>
        {{ inventory.count > 0 ? ` x${inventory.count}` : '' }}
      </span>
      <span class="inventory__size">{{ inventory.size }}m³</span>
      <button type="button" class="inventory__remove" @click="remove">
        <i class="vn-icons vn-icons-close"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'

export default {
  name: 'SmallInventoryItem',
  props: {
    inventory: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapWritableState(useStagesStore, ['values']),
    roomObj() {
      return this.values.rooms.find((r) => r.slug === this.inventory.room)
    },
    inventoryObj() {
      return this.roomObj.inventories.find(
        (i) => i.slug === this.inventory.slug
      )
    },
  },
  methods: {
    remove() {
      this.inventoryObj.count = 0
    },
  },
}
</script>

<style scoped lang="scss">
.inventory {
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid rgba(#c4c4c4, 0.16);

  &:last-child {
    border-bottom: 1px solid rgba(#c4c4c4, 0.16);
  }

  &__left {
    flex: 0 0 auto;
    width: 30px;
  }

  &__image {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #000;
    border-radius: 5px;

    img {
      height: 16px;
      width: auto;
    }
  }

  &__right {
    flex: 0 0 auto;
    width: calc(100% - 30px);
    padding-left: 10px;
    position: relative;
  }

  &__remove {
    @include reset-btn;
    position: absolute;
    right: 0;
    top: calc(50% - 10px);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    font-size: 12px;
    color: #e2001a;
  }

  &__name {
    display: block;
    margin: 0;
    font-weight: 700;
    font-size: 12px;
    padding-right: 25px;
  }

  &__size {
    font-size: 12px;
    color: var(--vn-secondary-color);
  }
}
</style>
